export default __webpack_public_path__ + "static/media/lucas-anderi.3c6c06d4.jpg";